/* eslint-disable @typescript-eslint/naming-convention */
import moment from 'moment';

import { RESIDENCE_ENUM } from '../../../utils/capitalUtils';

function matchedResidenceEnum(strOrInt) {
  // either user submit a string or Int, but the final result must be Int
  const matchedEnum = RESIDENCE_ENUM.filter((residenceEnum) => {
    return residenceEnum.id === strOrInt || residenceEnum.name === strOrInt;
  })[0];
  if (matchedEnum) return matchedEnum.id;
  throw new Error('form.residenceOwnership does not match any enum');
}

export function createKoinworksDto(
  form,
  bankStatements,
  bankStatementsCompany
) {
  const matchedCurrentResidenceOwnership = matchedResidenceEnum(
    form.current_residence_ownership
  );
  // TODO: matched the businessTypeEnum
  const {
    business_start_month: _businessStartMonth,
    business_start_year: _businessStartYear,
  } = form;
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const businessLengthYear = currentYear - _businessStartYear;
  const businessLengthMonth = currentMonth - Number(_businessStartMonth);
  const loansType =
    form.loans_type.toLowerCase() === 'individual'
      ? 'personal'
      : form.loans_type;
  const koinworksDto = {
    pre_approved_amount: form.pre_approved_amount,
    interest_rate: form.interest_rate,
    duration: form.duration,
    // this is loan type
    loans_type: loansType.toUpperCase(),
    callback_url: '',
    loan_info: {
      // personal upload documents
      ktp_data_url: form.ktp.code,
      kartu_keluarga_data_url: form.kk.code,
      npwp_data_url: form.npwp.code,
      ktp_pasangan_data_url: form.ktp_spouse
        ? form.ktp_spouse.code
        : form.ktp_spouse,
      bank_statement_last_3_months_data_url: bankStatements,
    },
    personal_info: {
      // personal info
      name: form.name,
      nik: form.nik,
      birth_date: form.birth_date
        ? moment(form.birth_date).format('DD/MM/YYYY')
        : form.birth_date,
      marital_status: form.marital_status,
      personal_email: form.personal_email,
      phone_number: `0${form.personal_phone_number}`, // this is personal phoen number
      home_address: form.address,
      home_city: form.home_city,
      home_province: form.home_province,
      home_zipcode: form.home_zipcode,
      home_phone_number: form.home_phone_number
        ? `0${form.home_phone_number}`
        : form.home_phone_number,
      residence_ownership: matchedCurrentResidenceOwnership,

      // business info
      business_name: form.business_name,
      business_type: form.business_type, // this is autofilled on sagas/capital based on borrowerProfile
      email: form.email,
      business_length_month: businessLengthMonth,
      business_length_year: businessLengthYear,
      start_date: form.start_date
        ? moment(form.start_date).format('DD/MM/YYYY')
        : form.start_date,
      business_description: form.business_description,
      business_company_brief: form.business_company_brief,
      business_address: form.business_address,
      business_city: form.business_city,
      business_province: form.business_province,
      business_zipcode: form.business_zipcode,

      // un-used form
      current_job_position: form.current_job_position,
      take_home_pay: form.take_home_pay,
      employment_status: form.employment_status,

      // bank info
      bank_name:
        form.bank_name === 'Other' ? form.other_bank_name : form.bank_name,
      account_no: form.account_no,
      bank_branch_name: form.bank_branch_name,
      bank_account_name: form.bank_account_name,
    },
    emergency_contact_info: {
      name: form.name_emergency,
      relationship: form.relationship,
      contact_no: `0${form.contact_number_emergency}`,
      address: form.emergency_address,
    },
  };

  if (
    koinworksDto.loans_type.toLowerCase() === 'personal' ||
    koinworksDto.loans_type.toLowerCase() === 'individual'
  )
    return koinworksDto;

  // FOR BUSINESS ONLY, ADD THIS
  koinworksDto.loan_info = {
    ...koinworksDto.loan_info, // business upload documents -- need both the documents from personal and all
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ ktp_pengurus_data_url: any; npwp_company_d... Remove this comment to see the full error message
    ktp_pengurus_data_url: form.ktp_komisaris_url.code,
    npwp_company_data_url: form.npwp_company.code,
    bank_statement_company_last_3_months_data_url: bankStatementsCompany,
    financial_statement_company_data_url: form.financial_statement.code,
    akta_pendirian_data_url: form.akte_perusahaan.code,
    akta_perubahan_data_url: form.akte_perubahan.code,
    siup_data_url: form.siup.code,
    sk_domisili_data_url: form.domicile.code,
    tdp_data_url: form.tdp.code,
  };

  return koinworksDto;
}
